import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import { FaRegEye } from 'react-icons/fa';

const ViewCase = ({ caseId, caseData }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  // Find the specific case by ID
  const currentCase = caseData.find(item => item.id === caseId);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Button icon={<FaRegEye />} onClick={showModal}>
        View
      </Button>
      <Modal 
        // title={currentCase ? currentCase.title : 'Case Details'} 
        open={isModalOpen} 
        onOk={handleOk} 
        onCancel={handleCancel}
      >
        {currentCase ? (
          <div>
            <p><strong>Title:</strong> {currentCase.title}</p>
            {/* Add more case details here as needed */}
            {currentCase.content && <p><strong>Content:</strong> {currentCase.content}</p>}
            {/* You can display other case properties as needed */}
          </div>
        ) : (
          <p>Case details not found</p>
        )}
      </Modal>
      
    </>
  );
};

export default ViewCase;